import createIcon from '../../createIcon';

/**
 * @component @name DisabledByDefault
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAzVjIxSDIxVjNIM1pNMTcgMTUuNTlMMTUuNTkgMTdMMTIgMTMuNDFMOC40MSAxN0w3IDE1LjU5TDEwLjU5IDEyTDcgOC40MUw4LjQxIDdMMTIgMTAuNTlMMTUuNTkgN0wxNyA4LjQxTDEzLjQxIDEyTDE3IDE1LjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DisabledByDefault = createIcon('DisabledByDefault', [
  [
    'path',
    {
      d: 'M3 3V21H21V3H3ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z',
      key: 'pb8av8',
    },
  ],
]);

export default DisabledByDefault;
